import React from 'react';

export const Skeleton = () => {
	return <>Loading the sandbox page...</>;
};
